export default __webpack_public_path__ + "images/Frozen-Yogurt.c2586a.jpg";